// extracted by mini-css-extract-plugin
export default {"terms":"Terms--terms--smGBJ"};